module.exports = __webpack_public_path__ + "static/media/clc_naming_competition_with_form_20201020.d44ff8b0.pdf";